import {
    apiClient,
} from '@/shared/api'

export interface LoginRequest {
    userName: string
    password: string
}

export interface LoginResponse {
    authenticationId: string
    email: string
}

export async function login(request: LoginRequest,): Promise<LoginResponse> {
    return apiClient.post<
        LoginResponse,
        LoginRequest
    >(
        '/authentication/login',
        request,
    )
}